import Checkbox from './CheckBox';
import CheckboxGroup from './CheckBoxGroup';
import CheckboxButton from './CheckBoxButton';

Checkbox.Group = CheckboxGroup;
Checkbox.Button = CheckboxButton;

export default Checkbox;
